import { Link } from '@com-delta-idp/mnx-ui-kit';
import { GenericLabel } from '@com-delta-idp/mnx-utils';

export interface ErrorMessage {
  message: Partial<GenericLabel>;
  featureTitle: string;
  action: Link;
  type: ComponentType;
  disable: boolean;
}

export type ComponentType = 'single-error' | 'message-error' | 'full-page';
